import { render, staticRenderFns } from "./SKMatch.vue?vue&type=template&id=ff5fd518"
import script from "./SKMatch.vue?vue&type=script&lang=js"
export * from "./SKMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports